import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=7b97a8dd&scoped=true"
import script from "./contents.vue?vue&type=script&lang=js"
export * from "./contents.vue?vue&type=script&lang=js"
import style0 from "./contents.vue?vue&type=style&index=0&id=7b97a8dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97a8dd",
  null
  
)

export default component.exports